import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Col } from 'react-bootstrap';

import FloatingButton from '../../components/FloatingButton/FloatingButton';
import { aprobador, solicitante, inspector, consultaServicios } from '../../security/constantsRols';
import { checkRol } from '../../security';
import { useFilterPinned } from '../../hooks/usePinnedFilter';
import { useDrawerContext } from '../../context/DrawerContext';

import ResultGrilla from './ServiceRequestGrilla/ServiceRequestGrilla';
import FilterServiceRequest from './FilterServiceRequest/FilterServiceRequest';

import './ServiceRequest.scss';

const ServiceRequest = () => {
  const { activeDrawer, setActiveDrawer, closeDrawer } = useDrawerContext();
  const { isFilterPinned, setIsFilterPinned } = useFilterPinned();
  const fixedDrawerHeightRef = useRef(null);

  const contentCardClass = !isFilterPinned ? 'container-filter-resultGrilla' : 'inbox-height-calc';

  const onAnchor = () => {
    setIsFilterPinned(!isFilterPinned);
  };

  const history = useHistory();

  const showCreateFn = () =>
    history.push({
      pathname: '/createMultiple',
      previusPath: '/'
    });

  const isApproverOnly =
    checkRol(aprobador) && !checkRol(solicitante) && !checkRol(consultaServicios);
  const isInspector = checkRol(inspector);
  const isInspectorRoute = history.location.pathname === '/inspector/service';

  useEffect(() => {
    if (isApproverOnly) {
      history.replace('/approver');

      return;
    }
    if (!isInspector && isInspectorRoute) {
      history.replace('/');
    }
  }, [history, isApproverOnly, isInspector, isInspectorRoute]);

  return (
    <div className="pas-container overflow-x-hidden">
      <div className={contentCardClass}>
        <FilterServiceRequest
          hideModal={closeDrawer}
          isFilterPinned={isFilterPinned}
          onAnchor={onAnchor}
          ref={fixedDrawerHeightRef}
          show={activeDrawer}
          showAnchor
        />

        <Col
          className="container-title-table service-tabs scrolled-table"
          ref={fixedDrawerHeightRef}
          sm={9}
        >
          <ResultGrilla isFilterPinned={isFilterPinned} setShowFilters={setActiveDrawer} />
        </Col>
      </div>
      {checkRol(solicitante) && <FloatingButton onClick={showCreateFn} />}
    </div>
  );
};

export default ServiceRequest;
